import React from 'react';
import Icon from '../../../../../components/Icon';
import { GalleryArrowLeft, GalleryArrowRight } from './styles';

export const NextArrow = (props) => {
  const { onClick, nextArrowActive } = props;

  return (
    <GalleryArrowRight
      onClick={onClick}
      nextArrowActive={nextArrowActive}
      right
    >
      <Icon name="keyboard_arrow_right" />
    </GalleryArrowRight>
  );
};

export const PrevArrow = (props) => {
  const { onClick, prevArrowActive } = props;

  return (
    <GalleryArrowLeft
      onClick={onClick}
      prevArrowActive={prevArrowActive}
      right
    >
      <Icon name="keyboard_arrow_left" />
    </GalleryArrowLeft>
  );
};
